import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalModel } from '../../../Models/ProposalModel'
import { proposalResMdl } from '../../../Models/proposalResMdl'
import { RegModel } from '../../../Models/RegModel';
import { FortPaymentReq } from '../../../Models/FortPaymentReq';
import Swal from 'sweetalert2';

@Component({
    selector: 'PayfortConfirm',
    templateUrl: './PayfortConfirm.html',
    styleUrls: ['./PayfortConfirm.css']
})
export class PayfortConfirm {

    public isShowLoading: boolean = false;
    public proposalObj: ProposalModel = new ProposalModel();
    public paymentReq: proposalResMdl = new proposalResMdl();
    public fortReq: FortPaymentReq = new FortPaymentReq();
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public PaymentMethod: string;
    public TotalAmount:number;

    
    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL) {
        this.isShowLoading = false;
        //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
        if (sessionStorage.getItem("paymentObj") != null) {
            this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
        }
        //this.fortReq = JSON.parse(sessionStorage.getItem("fortObj"));
        if (sessionStorage.getItem("fortObj") != null) {
        this.fortReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("fortObj")));
        }
        //this.paymentReq = JSON.parse(sessionStorage.getItem("PaymentReq"));
        if (sessionStorage.getItem("PaymentReq") != null) {
        this.paymentReq = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("PaymentReq")));
        }
        this.PaymentMethod = JSON.parse(sessionStorage.getItem("PaymentMethod"));
        this.TotalAmount= Number(this.fortReq.amount)/100

    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Payfort/PayfortConfirm/PayfortConfirm.ts